// Package Imports
import React from 'react';
// import { Spin } from 'antd';

import { Images } from 'core/common/imagePath';

type LoadingType = {
  componentLoading?: boolean;
};
const Loading = ({ componentLoading }: LoadingType) => (
  <div
    className={`flex items-center justify-center ${
      componentLoading ? 'h-full' : 'h-screen'
    } `}
  >
    {/* <Spin size="large" /> */}
    <img width="100px" src={Images.loaderGif} />
  </div>
);

export default Loading;
